import React ,{ forwardRef } from "react";
import styles from "./BenefitIllustration.module.css";
import { Form } from "react-bootstrap";
import { TPELogo } from "../../svg/SvgImages";
import TradComponents from "./TradComponents"
import UlipComponents from "./UlipComponents"


const EnforcedIllustrationSub = forwardRef((props, ref) => {
  const {
    data,
    formik,
    insurerData,
    onInputChange,
    isReturnMortalityChargeEligibleOptions,
    variantValue,
    setVariantValue,
    // DONT destructure ref here
  } = props;

  return (
    <div className={styles["sub-bg"]} ref={ref}>
      <div className="flex d-flex justify-content-center bg-white py-3 rounded-bottom border align-items-center gap-3">
        <h2 className="">Customer Information Sheet</h2>
        <TPELogo height={76} width={85} />
      </div>
      <Form onSubmit={formik.handleSubmit}>
        <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
          <div className="flex d-flex justify-content-between align-items-center gap-3">
            <span className={styles["sub-heading"]}> Policy Information</span>
            <span className={styles["sub-heading-icon"]}>01</span>
          </div>

          {/* <div className="flex d-flex flex-column justify-content-center">
          <span >    <strong>  Insurance Company</strong></span>
          <span>      Bharti AXA Life..</span>
        </div> */}

          <div className="">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-3 mb-3">
                <div className="d-flex flex-column justify-content-center border p-2">
                  {/* <span>
                  <strong>Insurance Company*</strong>
                </span>
                <span>{data?.policy?.insurer?.name}</span> */}
                  <Form.Label column className="edit-task-label">
                    Insurance Company<span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  <Form.Select
                    //  isInvalid={!!errorsMessage[insurerId]}
                    aria-label="Default select example"
                    onChange={(e) => onInputChange(e)}
                    name="insurerId"
                    value={formik.values.insurerId}
                  >
                    <option key={3434} value={""} disabled>
                      Select option
                    </option>
                    {insurerData.map((item) => {
                      return (
                        <option key={item.insurerId} value={item.insurerId}>
                          {item.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.insurerId}
                  </Form.Control.Feedback>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-3 mb-3">
                <div className="d-flex flex-column justify-content-center border p-2">
                  {/* <span>
                  <strong>Policy Number*</strong>
                </span>
                <span>{formik?.values?.policyNumber}</span> */}
                  <Form.Label column className="edit-task-label">
                    Policy Number<span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="policyNumber"
                    value={formik.values.policyNumber}
                    onChange={onInputChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.policyNumber &&
                      !!formik.errors.policyNumber
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.policyNumber}
                  </Form.Control.Feedback>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-3 mb-3">
                <div className="d-flex flex-column justify-content-center border p-2">
                  {/* <span>
                  <strong>Current Fund Value*</strong>
                </span>
                <span>{formik?.values?.currentFundValue}</span> */}
                  {/* <Col sm={2}> */}
                  <Form.Label column className="edit-task-label">
                    Current Fund Value<span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="currentFundValue"
                    value={formik.values.currentFundValue}
                    onChange={onInputChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.currentFundValue &&
                      !!formik.errors.currentFundValue
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.currentFundValue}
                  </Form.Control.Feedback>
                  {/* </Col> */}
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-3 mb-3">
                <div className="d-flex flex-column justify-content-center border p-2">
                  {/* <span>
                  <strong>Return Calculation*</strong>
                </span>
                <span>{formik?.values?.returnCalculation}</span> */}
                  <Form.Label column className="edit-task-label ">
                    Return Calculation<span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="returnCalculation"
                    value={formik.values.returnCalculation}
                    onChange={onInputChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.returnCalculation &&
                      !!formik.errors.returnCalculation
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.returnCalculation}
                  </Form.Control.Feedback>
                </div>
              </div>
              {isReturnMortalityChargeEligibleOptions && (
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div className="d-flex flex-column justify-content-center border p-2">
                    {/* <span>
                  <strong>Return Calculation*</strong>
                </span>
                <span>{formik?.values?.returnCalculation}</span> */}
                    {
                      <>
                        <Form.Label column className="edit-task-label">
                          Variant
                        </Form.Label>

                        <Form.Select
                          //  isInvalid={!!errorsMessage[insurerId]}
                          aria-label="Default select example"
                          onChange={(e) => {
                            setVariantValue(e.target.value);
                          }}
                          name="isReturnMortalityChargeEligible"
                          value={variantValue ?? ""}
                        >
                          <option key={3434} value={"true"} disabled>
                            Select option
                          </option>
                          {isReturnMortalityChargeEligibleOptions.map(
                            (item, index) => {
                              return (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              );
                            }
                          )}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.isReturnMortalityChargeEligible}
                        </Form.Control.Feedback>
                      </>
                    }
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex d-flex justify-content-evenly align-items-center">
            <button type="submit" className={styles["sub-btn"]}>
              Know Your Benefits
            </button>
          {data?.fundCharges&&  <strong>
              *The last 3 years average return on "{data?.fundCharges?.name}" is {" "}
              {data?.fundCharges?.fmcTwoYearsAgo}%
            </strong>}
          </div>
        </div>
      </Form>
      {data && (
        <>
       

          {data?.policy?.product?.productType === "ULIP" && (
            <UlipComponents formik={formik} data={data}  />
          )}
           {data?.policy?.product?.productType === "TRAD" && (
           <TradComponents formik={formik} data={data} onInputChange={onInputChange}/>
          )}
        </>
      )}
    </div>
  );
});


export default EnforcedIllustrationSub;
